export function getSentryFrontendAllowUrls(): Array<string | RegExp> {
  return [/localhost/, /embarkvet.com/];
}
